(function () {
  function initCarousel(section) {
    if (section.dataset.pcInit === '1') return;
    section.dataset.pcInit = '1';

    var viewport = section.querySelector('.portfolio-carousel__viewport');
    var track = section.querySelector('.portfolio-carousel__track');
    if (!viewport || !track) return;

    var direction = section.dataset.direction === 'right' ? 1 : -1;
    var speedSeconds = parseFloat(section.dataset.speed) || 40;
    var resumeDelayMs = (parseFloat(section.dataset.resumeDelay) || 5) * 1000;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var halfWidth = 0;
    var position = 0;
    var pxPerMs = 0;
    var lastTime = 0;
    var rafId = null;
    var isDragging = false;
    var dragPointerId = null;
    var dragStartX = 0;
    var dragStartPosition = 0;
    var hasMoved = false;
    var resumeTimeoutId = null;
    var isPaused = false;

    function measure() {
      halfWidth = track.scrollWidth / 2;
      pxPerMs = reducedMotion ? 0 : halfWidth / (speedSeconds * 1000);
    }

    function normalize(pos) {
      if (halfWidth <= 0) return pos;
      while (pos <= -halfWidth) pos += halfWidth;
      while (pos > 0) pos -= halfWidth;
      return pos;
    }

    function apply() {
      track.style.transform = 'translate3d(' + position + 'px, 0, 0)';
    }

    function tick(time) {
      if (!lastTime) lastTime = time;
      var dt = time - lastTime;
      lastTime = time;

      // Cap dt para evitar saltos cuando la pestaña vuelve del background
      // o cuando el primer frame se ejecuta tarde.
      if (dt > 64) dt = 16;

      if (!isDragging && !isPaused && pxPerMs > 0) {
        position += direction * pxPerMs * dt;
        position = normalize(position);
        apply();
      }

      rafId = requestAnimationFrame(tick);
    }

    function start() {
      if (rafId !== null) return;
      lastTime = 0;
      rafId = requestAnimationFrame(tick);
    }

    function scheduleResume() {
      clearTimeout(resumeTimeoutId);
      resumeTimeoutId = setTimeout(function () {
        isPaused = false;
        lastTime = 0;
      }, resumeDelayMs);
    }

    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      // No activamos drag ni pointer capture hasta detectar movimiento real.
      // Esto permite que un click limpio se propague al <a> de la card.
      hasMoved = false;
      dragPointerId = e.pointerId;
      dragStartX = e.clientX;
      dragStartPosition = position;
    }

    function onPointerMove(e) {
      if (dragPointerId === null || e.pointerId !== dragPointerId) return;
      var delta = e.clientX - dragStartX;

      if (!isDragging) {
        if (Math.abs(delta) <= 4) return;
        // Umbral superado: ahora sí activamos el modo drag.
        isDragging = true;
        isPaused = true;
        hasMoved = true;
        clearTimeout(resumeTimeoutId);
        try { viewport.setPointerCapture(e.pointerId); } catch (_) {}
        track.classList.add('is-dragging');
      }

      position = normalize(dragStartPosition + delta);
      apply();
    }

    function endDrag(e) {
      if (e && e.pointerId !== dragPointerId) return;
      dragPointerId = null;
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
      if (e) {
        try { viewport.releasePointerCapture(e.pointerId); } catch (_) {}
      }
      scheduleResume();
    }

    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove);
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);

    // Bloquea el click si el usuario arrastró (>4px)
    viewport.addEventListener('click', function (e) {
      if (hasMoved) {
        e.preventDefault();
        e.stopPropagation();
        hasMoved = false;
      }
    }, true);

    // Evita el drag fantasma de las imágenes en navegadores
    track.querySelectorAll('img').forEach(function (img) {
      img.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });

    // Re-medir al cambiar tamaño / orientación
    var resizeTimeout;
    function onResize() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        var oldHalf = halfWidth;
        measure();
        if (oldHalf > 0 && halfWidth > 0) {
          position = (position / oldHalf) * halfWidth;
        }
        apply();
      }, 150);
    }
    window.addEventListener('resize', onResize);

    // Forzar carga inmediata de todas las imágenes del carrusel. Si quedan
    // en lazy, el browser no las decodifica hasta que entran a viewport y
    // eso causa jank visible al iniciar el auto-scroll.
    var imgs = track.querySelectorAll('img');
    imgs.forEach(function (img) {
      if (img.loading === 'lazy') img.loading = 'eager';
      if ('fetchPriority' in img) img.fetchPriority = 'high';
    });

    // Medición inicial y arranque inmediato. Las cards tienen width fijo,
    // así que no necesitamos esperar a las imágenes para arrancar.
    measure();
    apply();
    start();

    // Re-medir cuando las imágenes terminen de cargar (por si el navegador
    // ajusta el layout). No bloquea el arranque del auto-scroll.
    imgs.forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        var oldHalf = halfWidth;
        measure();
        if (oldHalf > 0 && halfWidth > 0) {
          position = (position / oldHalf) * halfWidth;
        }
      }, { once: true });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.portfolio-carousel').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init al recargar la sección
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
